export const DEFAULT_API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

export const STORAGE_KEYS = {
  user: 'waitercall.authUser',
  token: 'waitercall.token',
  tokenExpires: 'waitercall.tokenExpires',
  authSessionMode: 'waitercall.authSessionMode',
  companyId: 'waitercall.companyId',
  restaurantId: 'waitercall.restaurantId'
};

export const UI_EVENTS = {
  scopeRefresh: 'waitercall:scope-refresh'
};
